/** Les jours où les deux compagnies volent : moitié de chaque couleur. */
const BOTH_BACKGROUND = 'bg-[linear-gradient(135deg,var(--color-info-subtle)_50%,var(--color-danger-subtle)_50%)]';
export const HIGHLIGHT_TONE_CLASSES = {
    both: {
        day: `${BOTH_BACKGROUND} text-foreground`,
        dot: `${BOTH_BACKGROUND} ring-muted-foreground`,
        text: 'text-foreground',
    },
    first: {
        day: 'bg-info-subtle text-info-foreground',
        dot: 'bg-info-subtle ring-info',
        text: 'text-info-foreground',
    },
    second: {
        day: 'bg-danger-subtle text-danger-foreground',
        dot: 'bg-danger-subtle ring-danger',
        text: 'text-danger-foreground',
    },
    warning: {
        day: 'bg-warning-subtle text-warning-foreground',
        dot: 'bg-warning-subtle ring-warning',
        text: 'text-warning-foreground',
    },
};
export const HIGHLIGHT_TONES = Object.keys(HIGHLIGHT_TONE_CLASSES);
/**
 * Mises en avant pendant le choix du retour : un clic avant le départ en fait le
 * nouveau départ, ces jours gardent donc les vols de l'aller ; le reste, ceux du retour.
 */
export function returnStepHighlights(departure, outbound = [], inbound = []) {
    return HIGHLIGHT_TONES.flatMap((tone) => {
        const before = outbound.find((h) => h.tone === tone);
        const after = inbound.find((h) => h.tone === tone);
        const dates = [
            ...(before?.dates.filter((d) => d < departure) ?? []),
            ...(after?.dates.filter((d) => d >= departure) ?? []),
        ];
        const label = after?.label ?? before?.label;
        return label && dates.length > 0 ? [{ dates, label, tone }] : [];
    });
}
/** Modificateurs react-day-picker à passer au calendrier pour ces mises en avant. */
export function toHighlightModifiers(highlights = []) {
    return Object.fromEntries(highlights.map((h) => [`highlight_${h.tone}`, h.dates]));
}
